import React from 'react';
import BorrowingHeader from '../../shared/BorrowingHeader';

export default function InterlibraryLoansTitle() {
  return (
    <BorrowingHeader
      headingKey="section_title_ill" />
  );
}



// WEBPACK FOOTER //
// ./app/components/borrowing/interlibraryLoans/InterlibraryLoansTitle/InterlibraryLoansTitle.jsx